import { render } from "./Seikyusyocreatenotsales.vue?vue&type=template&id=59413048&scoped=true&ts=true"
import script from "./Seikyusyocreatenotsales.vue?vue&type=script&lang=ts"
export * from "./Seikyusyocreatenotsales.vue?vue&type=script&lang=ts"

import "./Seikyusyocreatenotsales.vue?vue&type=style&index=0&id=59413048&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59413048"]])

export default __exports__